var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 2V12C27 13.3261 27.5268 14.5979 28.4645 15.5355C29.4021 16.4732 30.6739 17 32 17H42M29.5 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V47C2 48.3261 2.52678 49.5979 3.46447 50.5355C4.40215 51.4732 5.67392 52 7 52H37C38.3261 52 39.5979 51.4732 40.5355 50.5355C41.4732 49.5979 42 48.3261 42 47V14.5L29.5 2Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.4539f15be32da11f273a6b7d4e554c34.svg";
export { ForwardRef as ReactComponent };